import bash from 'highlight.js/lib/languages/bash'

const SUBCOMMANDS = [
  'account',
  'add',
  'batch',
  'bucket',
  'completion',
  'get',
  'install',
  'login',
  'logout',
  'man',
  'print',
  'skill',
  'status',
  'targets',
  'verify',
  'version'
].join('|')

// A command starts a line, follows a pipe or `&&`, or follows env vars.
const COMMAND_START = '(?:^\\s*|[|;&]\\s*)(?:[A-Z_]+=\\S+\\s+)*'
const COMMAND = '[a-z][\\w.-]*'

// Bash, plus command names, their subcommands, and flags.
export default function bashWithCommands(hljs) {
  const language = bash(hljs)

  return {
    ...language,
    contains: [
      {
        scope: 'title.function',
        match: new RegExp(`(?<=${COMMAND_START})${COMMAND}`)
      },
      {
        scope: 'keyword',
        match: new RegExp(
          `(?<=${COMMAND_START}${COMMAND}(?:\\s+(?:${SUBCOMMANDS}))*\\s+)` +
            `(?:${SUBCOMMANDS})\\b`
        )
      },
      { scope: 'attr', match: /(?<=\s)--?[a-zA-Z][\w-]*/ },
      ...language.contains
    ]
  }
}
